export const QUERY_PARAM_EPIC = 'epics' as const;
export const QUERY_PARAM_ISSUE_TYPE = 'issueTypes' as const;
